<template>
    <div class="modal is-active">
        <div class="modal-background" @click="toggleModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ $t("targetTypes.title") }}</p>
                <button class="delete" @click.prevent="toggleModal"></button>
            </header>
            <section class="modal-card-body">
                <div class="table-container">
                    <table class="table is-fullwidth is-striped is-hoverable">
                        <thead>
                            <tr>
                                <th>{{ $t("targetTypes.targetType") }}</th>
                                <th style="width: 9rem;">{{ $t("targetTypes.distanceMin") }}</th>
                                <th style="width: 9rem;">{{ $t("targetTypes.distanceMax") }}</th>
                                <th style="width: 9rem;">{{ $t("targetTypes.walkTimeMin") }}</th>
                                <th style="width: 9rem;">{{ $t("targetTypes.walkTimeMax") }}</th>
                                <th style="width: 7rem;" class="has-text-centered is-hidden">
                                    {{ $t("targetTypes.accessible") }}
                                </th>
                                <th class="is-hidden">{{ $t("targetTypes.notes") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="tt in allTargetTypes" :key="tt.id">
                                <td>
                                    <strong>{{ tt.name }}</strong>
                                    <div class="is-size-7 has-text-grey" v-if="tt.description">
                                        {{ tt.description }}
                                    </div>
                                </td>
                                <td>
                                    <input
                                        class="input"
                                        type="number"
                                        min="0"
                                        v-model.number="form[tt.id].distance_min"
                                        :placeholder="$t('targetTypes.optional')"
                                    />
                                </td>
                                <td>
                                    <input
                                        class="input"
                                        type="number"
                                        min="0"
                                        v-model.number="form[tt.id].distance_max"
                                        :placeholder="$t('targetTypes.optional')"
                                    />
                                </td>
                                <td>
                                    <input
                                        class="input"
                                        type="number"
                                        min="0"
                                        :placeholder="$t('targetTypes.optional')"
                                        :value="
                                            form[tt.id].walk_time_min == null
                                                ? ''
                                                : form[tt.id].walk_time_min
                                        "
                                        @input="
                                            e =>
                                                (form[tt.id].walk_time_min =
                                                    e.target.value === ''
                                                        ? null
                                                        : Number(e.target.value))
                                        "
                                    />
                                </td>
                                <td>
                                    <input
                                        class="input"
                                        type="number"
                                        min="0"
                                        :placeholder="$t('targetTypes.optional')"
                                        :value="
                                            form[tt.id].walk_time_max == null
                                                ? ''
                                                : form[tt.id].walk_time_max
                                        "
                                        @input="
                                            e =>
                                                (form[tt.id].walk_time_max =
                                                    e.target.value === ''
                                                        ? null
                                                        : Number(e.target.value))
                                        "
                                    />
                                </td>
                                <td class="has-text-centered is-hidden">
                                    <input
                                        type="checkbox"
                                        class="checkbox"
                                        v-model="form[tt.id].accessible"
                                    />
                                </td>
                                <td class="is-hidden">
                                    <input
                                        class="input"
                                        type="text"
                                        :placeholder="$t('targetTypes.notesPlaceholder')"
                                        v-model="form[tt.id].notes"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <footer class="modal-card-foot is-clearfix">
                <a class="button is-primary" :disabled="hasErrors" @click="save">{{
                    $t("generic.save")
                }}</a>
                <a class="button" @click="toggleModal">{{ $t("generic.cancel") }}</a>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: 'target-types-modal',
    props: {
        allTargetTypes: {
            type: Array,
            default: () => []
        },
        existing: {
            // Array of objects { target_type_id, distance_min, distance_max, walk_time_min, walk_time_max, accessible, notes }
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            form: {}
        };
    },
    computed: {
        hasErrors() {
            return false;
            // Basic validation: distance_min <= distance_max if both set
            /*
            return this.allTargetTypes.some(tt => {
                const f = this.form[tt.id];
                const a = Number(f.distance_min);
                const b = Number(f.distance_max);
                if(!isNaN(a) && !isNaN(b)) {
                    return a > b;
                }
                return false;
            });
             */
        }
    },
    watch: {
        existing: {
            deep: true,
            handler() {
                this.buildForm();
            }
        },
        allTargetTypes() {
            this.buildForm();
        }
    },
    created() {
        this.buildForm();
    },
    methods: {
        toggleModal() {
            this.$emit('toggle-modal');
        },
        buildForm() {
            // Initialize defaults per target type, merge with existing values from campsiteCopy.target_types
            const defaults = {
                distance_min: null,
                distance_max: null,
                walk_time_min: null,
                walk_time_max: null,
                accessible: false,
                notes: ''
            };
            console.log('gk-debug', 'existing', this.existing);
            console.log('gk-debug', 'all', this.allTargetTypes);

            const byId = {};
            (this.existing || []).forEach(function(e) {
                if(e) {
                    if(e.target_type_id != null) {
                        byId[e.target_type_id] = { ...e };
                    } else if(e.target_type && e.target_type.id != null) {
                        byId[e.target_type.id] = { ...e };
                    }
                }
            });

            // Reset form to avoid stale references
            this.form = {};
            (this.allTargetTypes || []).forEach(tt => {
                const existing = byId[tt.id] || {};
                this.$set(this.form, tt.id, {
                    distance_min:
                        existing.distance_min != null
                            ? existing.distance_min
                            : defaults.distance_min,
                    distance_max:
                        existing.distance_max != null
                            ? existing.distance_max
                            : defaults.distance_max,
                    walk_time_min:
                        existing.walk_time_min != null
                            ? existing.walk_time_min
                            : defaults.walk_time_min,
                    walk_time_max:
                        existing.walk_time_max != null
                            ? existing.walk_time_max
                            : defaults.walk_time_max,
                    accessible:
                        existing.accessible != null ? existing.accessible : defaults.accessible,
                    notes: existing.notes != null ? existing.notes : defaults.notes
                });
            });
        },
        save() {
            // Normalize walk_time proxies: convert empty string to null
            const result = this.allTargetTypes.map(tt => {
                const f = this.form[tt.id];
                const toNum = v => (v === '' || v === null || v === undefined ? null : Number(v));
                return {
                    target_type_id: tt.id,
                    distance_min: toNum(f.distance_min),
                    distance_max: toNum(f.distance_max),
                    walk_time_min: toNum(f.walk_time_min),
                    walk_time_max: toNum(f.walk_time_max),
                    accessible: !!f.accessible,
                    notes: f.notes || ''
                };
            });
            this.$emit('save', result);
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-card {
    width: 75%;
    max-width: 1200px;
    max-height: 75vh;
    display: flex;
    flex-direction: column;
}

th,
td {
    vertical-align: middle !important;
}

td input[type="number"] {
    text-align: right;
}

/* hide currently unused columns but keep data in payload */
.is-hidden {
    display: none !important;
}

.modal-card-body {
    overflow: auto;
}

.table-container {
    max-height: calc(75vh - 160px);
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/components/target-types/index.vue